/* Blueprint corner ticks — small filled squares at the four corners of a
   container. Parent must be position:relative for placement to work.
   Ported from design_handoff_daedalus/design_files/brand.jsx */

type Props = { size?: number };

export function CornerTicks({ size = 10 }: Props) {
  const base: React.CSSProperties = {
    position: 'absolute',
    width: size,
    height: size,
    border: '1px solid var(--rule)',
    background: 'var(--bg-2)',
    zIndex: 2,
  };
  const half = size / 2;
  return (
    <>
      <span style={{ ...base, top: -half, left: -half }} />
      <span style={{ ...base, top: -half, right: -half }} />
      <span style={{ ...base, bottom: -half, left: -half }} />
      <span style={{ ...base, bottom: -half, right: -half }} />
    </>
  );
}
